import React from 'react'

import type { ListCustomerProps } from './ListCustomerContent'

import { Link } from 'react-router-dom'

import ListCustomerContent from './ListCustomerContent'

export type { ListCustomerProps } from './ListCustomerContent'
export { LIST_CUSTOMER_H } from './ListCustomerContent'

export default React.memo<ListCustomerProps>(function ListCustomer({
  itemKey,
  ...rest
}): React.ReactElement {
  return (
    <Link style={linkStyle} to={`/customers/${itemKey}`}>
      <ListCustomerContent itemKey={itemKey} {...rest} />
    </Link>
  )
})

const linkStyle: React.CSSProperties = {
  textDecoration: 'none',
  color: 'inherit',
  display: 'block',
}
